import { Injector } from "@dojo/framework/core/Injector";
import { IPresetGeometry } from "../widgets/interfaces/model/geometry/PresetGeometry";

/**
 * Preset shape geometry injector
 */
export class PresetShapeInjector extends Injector {
	private _presetGeometries: [string, IPresetGeometry];

	/**
     * @param presetGeometries Collection of preset geometries
     */
	constructor(presetGeometries: [string, IPresetGeometry]) {
		super({ presetGeometries });
		this._presetGeometries = presetGeometries;
	}

	get presetGeometries(): [string, IPresetGeometry] {
		return this._presetGeometries;
	}
	public get(): PresetShapeInjector {
		return this;
	}
}
